export default function checkReferrer(...stringsArray) {
	return stringsArray.every((string) => document.referrer.includes(string));
}
export const isMultiforceReferrer = () =>
	checkReferrer('multiforce', 'servicehouse');
